import React, { useContext, useEffect, useRef, useState } from "react";
import "../../assets/css/rcTree.css";
import Tree from "rc-tree";
import { useSelector,useDispatch } from "react-redux";
import { cloneDeep, isEqual, debounce, } from "lodash";
import { treeActions } from "../../redux/slices/treeSlice";
import { api } from "../../redux/api";
import DragDropTemplate from "../ContextMenu/InboundTemplateActions/DragDropTemplate";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { addAdditionalTemplateHeaderDetails, rcTreeToInboundTemplate, rcTreeToOutboundTemplate, rcTreeToOutboundXML, rcTreeToWorkflowTemplate } from "../../utils/rctreeDataConversion";
import ErrorModal from "../ItemProperties/Forms/FieldDataValidation/ErrorModal";
import { useTranslation } from "react-i18next";
import { CopyInboundTemplate, DeleteInboundTemplate } from "../ContextMenu/WorkflowGroupActions";
import { createThrottledFunction, filterNestedData, getParentKey, scrollToSelectedItem } from "../../utils/utilFunctions";
import { CircularProgress, Tooltip, styled, tooltipClasses } from "@mui/material";
import { setLoadTemplateOnLanding } from "../../redux/slices/queryParamsSlice";

const nodeIcon = {
  // inboundTemplate: 'GET_DATA', 
  outboundTemplate: "SEND_DATA", 
  workflow: 'CALL_WORKFLOW',
  workflowGroup: 'RECORD',
  DOCUMENT: 'TRACKINGREPORT'
}

const iconByLocation = {
  SERVER: 'SERVER',
  BOTH: 'SERVER_USER',
  USERSPACE: 'USER_SPACE'
}

export default function WorkflowGroupsTree({parentRef,searchValue}) {
  const treeRef  = useRef();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const parentScreen = useContext(ParentScreenCtx);
  const state = useSelector((state) => state);
  const urlParams = useSelector((state) => state.queryParams);
  const { leftTree, rightTree, forceTemplate } = useSelector((state) => state.treeData[parentScreen]);
  const pendingAcceleratorConfig = useSelector((state) => state.treeData?.pendingAcceleratorConfigDialog);
  const acceleratorWorkflowQueue = useSelector((state) => state.treeData?.acceleratorWorkflowQueue);
  const stateTreeData = useSelector((state) => state.treeData);
  const { selectedNode } = leftTree.tree.body;
  const contextAction = leftTree.contextAction;
  const leftTranslatedData = leftTree.tree.body.translatedData;
  const [show, setShow] = useState(false);
  const [sourceWfg, setSourceWfg] = useState();
  const [draggedTemp, setDraggedTemp] = useState();
  const [draggedTempInfo, setDraggedTempInfo] = useState();
  const [unsavedArr, setUnsavedArr] = useState([]);
  const [errorModal, setErrorModal] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState([]);
  // const [autoExpandParent, setAutoExpandParent] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [destinationWfg, setDestinationWfg] = useState();
  const [copyInboundModal, setCopyInboundModal] = useState(false);
  const [deleteInboundModal, setDeleteInboundModal] = useState(false);
  const [draggedNode, setDraggedNode] = useState();
  const [treeData, setTreeData] = useState(leftTranslatedData)
  const [tempExpendedKeys, setTempExpandedKeys] = useState([]);
  const { account } = useSelector(state => state.queryParams);
  const { unsavedTemplates } = useSelector((state) => state.treeData);
  const [selectTemplateOnLoad, setSelectTemplateOnLoad] = useState(false);

  // const selectedTemplate = useSelector((state) => state.treeData[parentScreen]?.leftTree?.tree?.body?.selectedNode?.title)
  // const selectedWFG = useSelector((state) => state.treeData[parentScreen]?.leftTree?.tree?.body?.selectedNode?.workflowGroup)
  // const type = useSelector((state) => state.treeData[parentScreen]?.leftTree?.tree?.body?.selectedNode?.type)
  // const templateAction = useSelector((state)=>state.treeData[parentScreen].leftTree.templateAction);
  
  // loop thru workflow_groups arr, return whether template exists in wfg.
  const findTemplateInWFGTree = (wfGroup, template, list) => {
    let templateFound = false;
    let templateType = 
      parentScreen === "inbound" ? "inbound_templates" :
      parentScreen === "outbound" ? "outbound_templates" :
      parentScreen === "workflow" ? "workflows" :
      false;

    if (templateType) {
      list.forEach((o, k) => {
        if (templateFound) return;
        if (o[templateType]?.length > 0 && wfGroup === o.name) {
          o[templateType].forEach((obj, key) => {
            if (obj.name === template) templateFound = true;
          })
        }
      });
    }
    
    
    return templateFound;
  }

  const handleWorkflowSelect = (event, forceSelect, source) => {
    const skipSaveForAccelerator = parentScreen === 'workflow' && (acceleratorWorkflowQueue || pendingAcceleratorConfig);
    //Template change, dispatch path change and initiate get_inbound_template request
    //Dispatching selected node for Selecting Node when Changing (Moved Here Because it is needed for Showing Save Dialog)
    dispatch(
      treeActions.setLeftTreeSelectedNode(
        cloneDeep({
          screen: parentScreen,
          type: "body",
          data: event.node
        })
      )
    );

    //clears all right tree template data from redux store.
    const clearTemplateData = () => {
      ["header", "body", "trailer"].forEach(e => {
        dispatch(treeActions.setRightTreeData({screen: parentScreen, type: e, data: []}));
        dispatch(treeActions.setNewRightTreeTranslatedData({screen: parentScreen, type: e, data: [], templateChanged: false}))
        dispatch(treeActions.setRightTreeSelectedNode({screen: parentScreen, type: e, data: {}}))
      })
      dispatch(treeActions.setRightTreeInitialTemplateHeader({screen: parentScreen, value: []}));
      dispatch(treeActions.setRightTreeTemplateHeader({screen: parentScreen, value: [], templateChanged: false}));
    }

    //start template fetching process
    const fetchNewTemplate = () => {
      if (event.node.type === "workflowGroup") return;
      //define endpoint based on screen
      let dispatchType = parentScreen === 'outbound' ?
        'getOutboundTemplate' : parentScreen === 'workflow' ?
          'getWorkflowTree' : 'getInboundTemplate';
      dispatch(treeActions.setRightTreeLoading({screen: parentScreen, data: true}));
      dispatch(treeActions.setRightTreePath({
        screen: parentScreen,
        workflowGroup: event.node.workflowGroup, 
        template: event.node.title
      }));
      dispatch(api.endpoints[dispatchType].initiate({
        account,
        workflowGroupName: encodeURIComponent(event.node.workflowGroup),
        templateName: event.node.title,
      }, {
        subscribe: false, forceRefetch: true
      }))
      .catch(() => {
        dispatch(treeActions.setTemplateFetchError({screen: parentScreen, data: true}));
        dispatch(treeActions.setRightTreeLoading({screen: parentScreen, data: false}));
      })
      
    }

    //send unsaved data to user space
    function sendUnsavedData(data) {
      // Added Promise so we can do other actions after this api Call
      return new Promise((resolve, reject) => {
        if (
          data &&
          account &&
          leftTree.tree.body.selectedNode &&
          leftTree.tree.body.selectedNode.workflowGroup &&
          leftTree.tree.body.selectedNode.title
        ) {
          dispatch(treeActions.setLoadingLeftData({
            screen: parentScreen,
            isLoading: true,
            templateName: leftTree.tree.body.selectedNode.title,
            workflowGroupName:leftTree.tree.body.selectedNode.workflowGroup
          }))
          if (parentScreen === 'inbound') {
            const templateHeaderData = {
              ACCOUNT_NAME: account,
              TEMPLATE: encodeURIComponent(leftTree.tree.body.selectedNode.title),
              WF_GROUP: leftTree.tree.body.selectedNode.workflowGroup,
            }
            
            const requestSave = () => {
              return dispatch(api.endpoints.saveUserInboundTemplate.initiate(
                {
                  account,
                  workflowGroupName: templateHeaderData.WF_GROUP,
                  templateName: templateHeaderData.TEMPLATE,
                  data : addAdditionalTemplateHeaderDetails(data, templateHeaderData,false),
                }, { forceRefetch: true }
              )).then((res) => {
                if (res.isError && res.data.current_state === "ERROR") {
                  //case: response error or network issue
                  //TODO: temporary alert until save is fully tested and ready.
                  alert('*Dev message* - Failure to save unsaved template data. Check console to debug.');
                  console.warn('Save request failure: ', res);
                } else if (!res.isSuccess) {
                  //case: unexpected response
                  //TODO: temporary console.log until save is fully tested and ready.
                  console.warn('*Dev message* Save request failure - unexpected: ', res);
                }
                dispatch(api.endpoints.getUnsavedTemplates.initiate(
                  { account }, { forceRefetch: true }
                ));
                resolve();
              })
              .catch((err) => {
                reject();
              })
            }
            dispatch(api.endpoints.getCopyInboundTemplateList.initiate({account}, {forceRefetch: true}))
            .then((res) => {
              if (res?.data?.data?.workflow_groups) {
                //verify that template exists still before dispatching a save call.
                // useful to prevent save after a delete.
                if (findTemplateInWFGTree(templateHeaderData.WF_GROUP, templateHeaderData.TEMPLATE, res.data.data.workflow_groups)) {
                  requestSave()
                } else resolve();
              } else {
                //dev warning for future error handling
                console.warn('Dev Message: error fetching inbound templates list:', res);
                reject();
              }
            })
  
          } if (parentScreen === 'outbound') {
            const templateHeaderData = {
              ACCOUNT_NAME: account,
              TEMPLATE: leftTree.tree.body.selectedNode.title,
              WF_GROUP: leftTree.tree.body.selectedNode.workflowGroup,
            }
            
            const requestSave = () => {
              dispatch(api.endpoints.saveUserOutboundTemplate.initiate(
                {
                  account,
                  workflowGroupName: templateHeaderData.WF_GROUP,
                  templateName: encodeURIComponent(templateHeaderData.TEMPLATE),
                  data : addAdditionalTemplateHeaderDetails(data, templateHeaderData,true),
                  source: source
                }, { forceRefetch: true }
              )).then((res) => {
                if (res.isError && res.data.current_state === "ERROR") {
                  //case: response error or network issue
                  //TODO: temporary alert until save is fully tested and ready.
                  alert('*Dev message* - Failure to save unsaved template data. Check console to debug.');
                  console.warn('Save request failure: ', res);
                } else if (!res.isSuccess) {
                  //case: unexpected response
                  //TODO: temporary console.log until save is fully tested and ready.
                  console.warn('*Dev message* Save request failure - unexpected: ', res);
                }
                dispatch(api.endpoints.getUnsavedTemplates.initiate(
                  { account }, { forceRefetch: true }
                ));
                resolve();
              })
              .catch(err => {
                reject();
              })
            }
  
            dispatch(api.endpoints.getCopyOutboundTemplateList.initiate({account}, {forceRefetch: true}))
            .then((res) => {
              if (res?.data?.data?.workflow_groups) {
                //verify that template exists still before dispatching a save call.
                // useful to prevent save after a delete.
                if (findTemplateInWFGTree(templateHeaderData.WF_GROUP, templateHeaderData.TEMPLATE, res.data.data.workflow_groups)) {
                  requestSave()
                } else {
                  resolve();
                }
              } else {
                //dev warning for future error handling
                console.warn('Dev Message: error fetching outbound templates list:', res);
                reject();
              }
            })
          } if (parentScreen === 'workflow') {
            const templateHeaderData = {
              ACCOUNT_NAME: account,
              TEMPLATE: leftTree.tree.body.selectedNode.title,
              WF_GROUP: leftTree.tree.body.selectedNode.workflowGroup,
            }
            
            const requestSave = () => {
              dispatch(api.endpoints.saveUserWorkflowTemplate.initiate(
                {
                  account,
                  workflowGroupName: templateHeaderData.WF_GROUP,
                  templateName: encodeURIComponent(templateHeaderData.TEMPLATE),
                  data : data,
                  source: source
                }, { forceRefetch: true }
              )).then((res) => {
                if (res.isError && res.data.current_state === "ERROR") {
                  //case: response error or network issue
                  //TODO: temporary alert until save is fully tested and ready.
                  alert('*Dev message* - Failure to save unsaved template data. Check console to debug.');
                  console.warn('Save request failure: ', res);
                } else if (!res.isSuccess) {
                  //case: unexpected response
                  //TODO: temporary console.log until save is fully tested and ready.
                  console.warn('*Dev message* Save request failure - unexpected: ', res);
                }
                dispatch(api.endpoints.getUnsavedTemplates.initiate(
                  { account }, { forceRefetch: true }
                ));
                resolve();
              })
              .catch(err => {
                reject();
              })
            }
  
            dispatch(api.endpoints.getWorkflowsCopy.initiate({account}, {forceRefetch: true}))
            .then((res) => {
              if (res?.data?.data?.workflow_groups) {
                //verify that template exists still before dispatching a save call.
                // useful to prevent save after a delete.
                if (findTemplateInWFGTree(templateHeaderData.WF_GROUP, templateHeaderData.TEMPLATE, res.data.data.workflow_groups)) {
                  requestSave()
                } else {
                  resolve();
                }
              } else {
                //dev warning for future error handling
                console.warn('Dev Message: error fetching outbound templates list:', res);
                reject();
              }
            })
          }
        } else {
          //if this case is fulfilled, need to find why.
          //console.log('selectedNode missing data');
          reject();
        }
      });
    }

    if (forceSelect) { // For forcefully sending data for unsaved changes in case of Rename template and creating new Template
      const requiredDataForTemplateHeader = {
        ACCOUNT_NAME: account,
        TEMPLATE: event.node.title,
        WF_GROUP: event.node.workflowGroup,
      };

      const prev = rightTree.initialFetchData;
      let curr =
        parentScreen === "inbound"
          ? rcTreeToInboundTemplate(rightTree.tree, requiredDataForTemplateHeader)
          : parentScreen === "outbound"
          ? (rightTree.tree.templateHeader.FILETYPE === "XML"
              ? rcTreeToOutboundXML(rightTree.tree, rightTree.initialFetchData)
              : rcTreeToOutboundTemplate(rightTree.tree, requiredDataForTemplateHeader))
          : parentScreen === "workflow"
          ? rcTreeToWorkflowTemplate(rightTree.tree)
          : false;

      if (!rightTree?.tree?.body?.translatedData?.length > 0) curr = false;

      clearTemplateData();
      fetchNewTemplate();

      const hasDiff =
        !!curr &&
        !isEqual(prev, curr) &&
        stateTreeData[parentScreen].templateChanged;

      // In accelerator flow, only save if there is an actual diff; outside accelerator keep old behavior
      if (skipSaveForAccelerator && parentScreen === "workflow") {
        if (hasDiff) {
          sendUnsavedData(curr).finally(() => {
            disableClickEventLeftTree(false);
          });
        } else {
          disableClickEventLeftTree(false);
        }
      } else {
        sendUnsavedData(curr).finally(() => {
          disableClickEventLeftTree(false);
        });
      }
    }
    else if (
      event?.node?.type === "inboundTemplate" ||
      event?.node?.type === "outboundTemplate" ||
      event?.node?.type === "workflow"
    ) {
      const templatePath = `${event.node.workflowGroup}/${event.node.title}`;

      //filter actions based on selected node
      if (rightTree.path && rightTree.path !== templatePath) {
        //case: switching between two different templates
        const requiredDataForTemplateHeader = {
          ACCOUNT_NAME: account,
          TEMPLATE: event.node.title,
          WF_GROUP: event.node.workflowGroup,
        }
        //compare prev curr data for diff
        const prev = rightTree.initialFetchData;
        let curr =
        parentScreen === "inbound"
          ? rcTreeToInboundTemplate(rightTree.tree, requiredDataForTemplateHeader)
            : parentScreen === "outbound"
          ? (rightTree.tree.templateHeader.FILETYPE === "XML" ? rcTreeToOutboundXML(rightTree.tree, rightTree.initialFetchData) : rcTreeToOutboundTemplate(rightTree.tree, requiredDataForTemplateHeader))
            : parentScreen === "workflow"
          ? rcTreeToWorkflowTemplate(rightTree.tree)
            : false;

        if (!rightTree?.tree?.body?.translatedData?.length > 0) curr = false;
        //case: diff in json  
        const hasDiff =
          !!curr &&
          !isEqual(prev, curr) &&
          stateTreeData[parentScreen].templateChanged;
        const shouldSave = skipSaveForAccelerator
          ? hasDiff
          : hasDiff || (source && stateTreeData[parentScreen].templateChanged);

        if (shouldSave) {
          clearTemplateData();
          fetchNewTemplate();
          sendUnsavedData(curr).finally(() => {
            disableClickEventLeftTree(false);
          });
        } else {
          disableClickEventLeftTree(false);
          clearTemplateData();
          fetchNewTemplate();
        }
      } else if (rightTree.path === "") {
        //case: selecting first template since page render
        fetchNewTemplate();
        disableClickEventLeftTree(false);
      } else {
        //case: selecting current selected template or switching screen tabs
       
        const requiredDataForTemplateHeader = {
          ACCOUNT_NAME: account,
          TEMPLATE: event.node.title,
          WF_GROUP: event.node.workflowGroup,
        }
        const prev = rightTree.initialFetchData;
        let curr =
          parentScreen === "inbound"
            ? rcTreeToInboundTemplate(rightTree.tree, requiredDataForTemplateHeader)
              : parentScreen === "outbound"
            ? (rightTree.tree.templateHeader.FILETYPE === "XML" ? rcTreeToOutboundXML(rightTree.tree, rightTree.initialFetchData) : rcTreeToOutboundTemplate(rightTree.tree, requiredDataForTemplateHeader))
              : parentScreen === "workflow"
            ? rcTreeToWorkflowTemplate(rightTree.tree)
              : false;

        if (!rightTree?.tree?.body?.translatedData?.length > 0) curr = false;

        //case: diff in json
        const hasDiff =
          !!curr &&
          !isEqual(prev, curr) &&
          stateTreeData[parentScreen].templateChanged;
        const shouldSave = skipSaveForAccelerator
          ? hasDiff
          : hasDiff || (source && stateTreeData[parentScreen].templateChanged);

        if (shouldSave) {
          sendUnsavedData(curr).finally(() => {
            disableClickEventLeftTree(false);
            dispatch(
              treeActions.setTemplateChanged({
                screen: parentScreen,
                data: false,
              })
            ); // after saving template to backend setting template Changed in Redux false;
          });
        } else {
          disableClickEventLeftTree(false);
        }
      }
    }
    // Resetting the Redux state when the selected node is a workflow group to prevent any data from
    // populating the right-hand side tree and template properties.
    else if (event?.node?.type === "workflowGroup") {
      dispatch(treeActions.setRightTreePath({
        screen: parentScreen,
        workflowGroup: '', 
        template: ''
      }));
      const requiredDataForTemplateHeader = {
        ACCOUNT_NAME: account,
        TEMPLATE: event.node.title,
        WF_GROUP: event.node.workflowGroup,
      }
      const prev = rightTree.initialFetchData;
      
      let curr =
          parentScreen === "inbound"
            ? rcTreeToInboundTemplate(rightTree.tree, requiredDataForTemplateHeader)
              : parentScreen === "outbound"
            ? (rightTree.tree.templateHeader.FILETYPE === "XML" ? rcTreeToOutboundXML(rightTree.tree, rightTree.initialFetchData) : rcTreeToOutboundTemplate(rightTree.tree, requiredDataForTemplateHeader))
              : parentScreen === "workflow"
            ? rcTreeToWorkflowTemplate(rightTree.tree)
              : false;

      if (!rightTree?.tree?.body?.translatedData?.length > 0) curr = false;
      
      //case: diff in json
      clearTemplateData();
      if (curr && !isEqual(prev, curr) && stateTreeData[parentScreen].templateChanged && !skipSaveForAccelerator) {
        sendUnsavedData(curr).finally(() => {
          disableClickEventLeftTree(false);
        });
      } else {
        disableClickEventLeftTree(false);
      }
    }
    else if (event?.node?.type === "DOCUMENT") {
      dispatch(treeActions.setShowDocFile(true));
      handleDocSelect(event);
    }
    dispatch(treeActions.setLeftTreeContextActionValue({
      screen: parentScreen,
      data: null
    }))

    //timed fallback incase something is wrong with response. will disable the page's Loading state after 25s
    setTimeout(() => {
      if (rightTree.loading) dispatch(treeActions.setRightTreeLoading({screen: parentScreen, data: false}));
      disableClickEventLeftTree(false);
    }, 25000)
  }

  const handleDocSelect = (event) => {
    let dispatchType = parentScreen === 'outbound' ?
        'getOutboundTemplate' : parentScreen === 'workflow' ?
          'getWorkflowTree' : 'getInboundTemplate';

    // sample file until backend returns mht/html files
    dispatch(treeActions.setLeftTreeSelectedNode({
      screen: parentScreen,
      type: "body",
      data: event.node || {}
    }))
  }

  const onExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys.filter(e => e?.split("-")?.length === 2));
  };

  const disableClickEventLeftTree = (disable) => {
    const leftTreeElement = document.getElementById(parentScreen === "outbound" ? "ob-wf-tree" : parentScreen === "inbound" ? "ib-wf-tree" : "workflow-tree");
    if(leftTreeElement) leftTreeElement.style.pointerEvents = disable ? "none" : "visible";
  }
  
  const onSelect = (_, info) => {
    if (leftTree?.loading || rightTree.loading || info.node.disabled) return;
    if (selectedKeys?.includes(info.node.key)) return;
    if (info.node?.type === "DOCUMENT") {
      dispatch(treeActions.setShowDocFile(true));
      handleDocSelect(info);
    } else {
      dispatch(treeActions.setShowDocFile(false));
      disableClickEventLeftTree(true);
      handleWorkflowSelect(info);
    }
    setSelectedKeys([info.node.key]);
  };

  const onDragStart = (info) => {
    info.event.dataTransfer.effectAllowed = "move"
    setDraggedTempInfo(info);
    setDraggedTemp(info.node.title);
    setSourceWfg(info.node.workflowGroup)
    setDraggedNode(info.node);
  };
  
  const onDrop = (info) => {
    if (
      info.dragNode.type !== "workflowGroup"  && 
      info.dragNode.type !== "DOCUMENT" &&
      info.dragNode.workflowGroup !== info.node.workflowGroup &&
      // info.dragNode.title !== info.node.title &&
      !info.node.children?.some(child => child.workflowGroup === info.dragNode.workflowGroup)
    ) {
      info.node.isLeaf ? setDestinationWfg(info.node.workflowGroup) : setDestinationWfg(info.node.title)
      setShow(true);
    }
  };
  const onRightClick = info => {
    if (leftTree?.loading || rightTree.loading || info.node.disabled) return;
    if (selectedKeys?.includes(info.node.key)) return;
    if (info.node?.type === "DOCUMENT") {
      dispatch(treeActions.setShowDocFile(true));
      handleDocSelect(info);
    } else {
      dispatch(treeActions.setShowDocFile(false));
      disableClickEventLeftTree(true);
      handleWorkflowSelect(info);
    }
    setSelectedKeys([info.node.key]);
  };

  const Icon = (node) => {
    if (
      (node.type === "inboundTemplate" ||
        node.type === "outboundTemplate" ||
        node.type === "workflow") &&
      ["SERVER", "BOTH", "USERSPACE"].includes(node?.location?.toUpperCase())
    ) {
      if (node?.location?.toUpperCase() === "SERVER") {
        return (
          <>
            <span
              className={
                node.hasOwnProperty("lockedBy") && node?.lockedBy !== ""
                  ? "LOCK"
                  : iconByLocation[node?.location?.toUpperCase()]
              }></span>
          </>
        );
      } else if (node?.location?.toUpperCase() === "BOTH") {
        return (
          <span
            className={
              node.hasOwnProperty("lockedBy") && node?.lockedBy !== ""
                ? "LOCK_AND_USERSPACE"
                : iconByLocation[node?.location?.toUpperCase()]
            }></span>
        );
      } else {
        return node?.disabled ? (
          <CircularProgress size={"16px"} />
        ) : (
          <span
            className={iconByLocation[node?.location?.toUpperCase()]}></span>
        );
      }
    } else {
      return node?.disabled ? (
        <CircularProgress size={"16px"} />
      ) : (
        <span className={nodeIcon[node.type]}></span>
      );
    }
  }
  
  // const titleRender = (node) => {
  //   return <span data-key={node.key}>{node.title}</span> 
  // }

  const titleRender = (node) => {
    let flagWfg = false;
    let flagTp = false;

    if (node.type === 'workflowGroup' && node.children) {
      node.children.forEach(o => {
        if (unsavedArr.includes(`${node.title}/${o.title}`)) {
          flagWfg = true;
        }
      })
    } else if (node.workflowGroup) {
      if (unsavedArr.includes(`${node.workflowGroup}/${node.title}`)) {
        flagTp = true;
      }
    }

    // Helper function to render the title with lock status
    const renderTitleWithLockStatus = (title) => {
      return node?.lockedBy && node?.lockedBy !== "" ? (
        <>
          {title}
          &nbsp; [<i style={{ margin: "2px" }}>{node.lockedBy}</i>]
        </>
      ) : (
        title
      );
    };

    //on node hover, will display to user that the bold means unsaved changes.
    // <UnsavedNode/> will display as inline text.
    // <UnsavedNodeAlt/> will display as a Tooltip message.
    if (flagWfg) {
      return (
        <UnsavedNode
          node={node}
          unsavedWfg={true}
          renderTitleWithLockStatus={renderTitleWithLockStatus}
        />
      );
    } else if (flagTp) {
      return (
        <UnsavedNode
          node={node}
          unsavedWfg={false}
          renderTitleWithLockStatus={renderTitleWithLockStatus}
        />
      );
    } else {
      return (
        <span data-key={node.key}>{renderTitleWithLockStatus(node.title)}</span>
      );
    }
  };

  //loop thru wfgroups, find specific node by name string and return it.
  const getNodeByWfGroup = (data, wfGroupName) => {
    let wfgNode;
    data.forEach((wfGroup) => {
      if (wfGroup.title === wfGroupName) wfgNode = wfGroup;
    });
    return wfgNode || false;
  }

  //loop thru wfgroup tree to find a template by name, and returns node. can also find template if wfgroup is not known.
  const getNodeByTemplate = (data, templateName, wfGroupName) => {
    const nameStr = typeof templateName === 'string' ? templateName : (templateName?.name ?? templateName?.title ?? '');
    let templateNode;
    // Helper function to compare template names
  const compareTemplateName = (template, searchName) => {
    const searchStr = typeof searchName === 'string' ? searchName : (searchName?.name ?? searchName?.title ?? String(searchName));
    if (template.type === 'DOCUMENT') {
      // For DOCUMENT type, compare complete name including extension
      return template.title === searchStr;
    } else {
      // For other types, skip extension comparison
      const templateBaseName = template.title?.split?.('.')[0] ?? '';
      const searchBaseName = searchStr.split('.')[0];
      return templateBaseName === searchBaseName;
    }
  };
    if (wfGroupName) {
      //case: wfgroup is supplied, only need to search that wfgroup for the template
      getNodeByWfGroup(data, wfGroupName).children?.forEach((template) => {
        if(compareTemplateName(template, nameStr)) templateNode = template;
      });
    } else {
      //case: wfgroup is not supplied, search every wfgroup and return first found template with matching name.
      data?.forEach((wfGroup) => {
        if (wfGroup.children) {
          wfGroup.children?.forEach((template) => {
            if (template.title === nameStr) templateNode = template; 
          })
        }
      });
    }
    return templateNode || false
  }

  // Given a template and wfgroup, sets proper states to reflect contextAction's values. 
  // Attempted to rewrite this function's logic for clarity and to prevent page error when copying a template.
  const handleSelectedNode = (contextAction, forceSelect, source) => {
    if (contextAction && contextAction.delete) {
      //when deleting a wfg, make sure to select first node in tree, but not the deleted node
      setSelectedKeys(['wfg-0']);
      dispatch(treeActions.setLeftTreeSelectedNode({
        screen: parentScreen,
        type: "body",
        data: leftTranslatedData?.[0] || {}
      }))
      return;
    }
    const setStateVals = (selectedNode, expandedKey) => {
      if (selectedNode) {
        setSelectedKeys([selectedNode.key]);
        if (selectedNode?.type === "workflowGroup"){
          const filteredArray = leftTranslatedData.filter( e => e.title !== selectedNode?.title) || [];
          const tempExpendedKeys = []
          filteredArray.forEach( (e, i) => {
            const previousKey = `wfg-${i}`;
            if(expandedKeys.includes(previousKey)) tempExpendedKeys.push(e.key);
          })
          setExpandedKeys(prev => Array.from(new Set([...prev, expandedKey])));
        } else {
          setExpandedKeys(prev => Array.from(new Set([...prev, expandedKey])));
        }
        handleWorkflowSelect({node: selectedNode}, forceSelect , contextAction?.source);
      }
    }
    
    let wfgNode = getNodeByWfGroup(leftTranslatedData, (contextAction.workflowGroup || contextAction))
    // console.log(leftTranslatedData, contextAction, wfgNode)
    
    if (contextAction.workflowGroup) {
      if (contextAction.name) {
        //Case: contextAction has both .workflowGroup and .name
        let templateNode = getNodeByTemplate(leftTranslatedData, contextAction.name, contextAction.workflowGroup);
        setStateVals(templateNode, wfgNode.key);
        // scrollToNode(templateNode);
      } else {
        //Case: contextAction has .workflowGroup but not .name
        setStateVals(wfgNode,wfgNode.key);
      }
    } else {
      //Case: contextAction is only a string of wfg value
      setStateVals(wfgNode, wfgNode.key);
    }
    
  }

  useEffect(() => {
    if (pendingAcceleratorConfig || acceleratorWorkflowQueue) return;
    if (!contextAction || !leftTranslatedData) return;
    // Do not let contextAction select workflow group when forceTemplate is selecting a template, or when viewing a template
    const wouldSelectGroupOnly = contextAction.workflowGroup && !contextAction.name;
    const forceTemplateSelecting = forceTemplate?.workflowGroup && forceTemplate?.template;
    const viewingTemplate = rightTree?.path && String(rightTree.path).includes('/') && rightTree.path !== '/';
    if (wouldSelectGroupOnly && (forceTemplateSelecting || viewingTemplate)) return;
    handleSelectedNode(contextAction);
  }, [contextAction, leftTranslatedData, pendingAcceleratorConfig, acceleratorWorkflowQueue, rightTree?.path, forceTemplate]);

  useEffect(() => {
    if (parentScreen === 'inbound') {
      setUnsavedArr(unsavedTemplates.inbound_templates.map(o => `${o.workflow_group}/${o.template}`));
    }
    if (parentScreen === 'outbound') {
      setUnsavedArr(unsavedTemplates.outbound_templates.map(o => `${o.workflow_group}/${o.template}`));
    }
    if (parentScreen === 'workflow') {
      setUnsavedArr(unsavedTemplates.workflow.map(o => `${o.workflow_group}/${o.template}`));
    }
  }, [unsavedTemplates]);

  useEffect(() => {
    let ft = forceTemplate;
    if (ft && ft.workflowGroup && ft.template) handleSelectedNode({ name: ft.template, workflowGroup: ft.workflowGroup });
  }, [forceTemplate]);

  useEffect(() => {
    if (!rightTree.loading) {
      const ft = forceTemplate;
      if (ft && ft.workflowGroup && ft.template && ft.forceSelect) {
        const templateName = typeof ft.template === 'object' ? (ft.template?.name ?? ft.template?.title) : ft.template;
        const normalizePath = (p) => (p || '').replace(/\.json$/i, '');
        const expectedPath = normalizePath(`${ft.workflowGroup}/${templateName}`);
        const currentPath = normalizePath(rightTree.path);
        const pathMatch = currentPath === expectedPath;
        if (pathMatch) {
          handleSelectedNode({ name: ft.template, workflowGroup: ft.workflowGroup }, ft.forceSelect);
        }
        dispatch(treeActions.setForceTemplate({ screen: parentScreen }));
      }
    }
  }, [rightTree.loading]);

  useEffect(() => {
    setSelectedKeys([selectedNode?.key]);
  },[selectedNode?.key])

  useEffect(() => {
    // console.log(selectedKeys, parentRef, contextAction)
    scrollToSelectedItem(selectedKeys, parentRef);
  }, [selectedKeys, treeData]);

  useEffect(() => {
    const filterData = (value = "") => {
    // If searchValue is empty, reset treeData and expanded keys
      if (!value.trim()) {
        setTempExpandedKeys([]);
      }
      else {
        setTempExpandedKeys(leftTranslatedData?.map(e => e.key));
      }
      
      // Filter leftTranslatedData based on search value
      const filteredData = filterNestedData(leftTranslatedData, value);
      setTreeData(filteredData);
      
      // Generate expanded keys
      const newExpandedKeys = [];
      const findParentKeys = (node) => {
        const parentKey = getParentKey(node.key, filteredData);
        if (parentKey) {
          newExpandedKeys.push(parentKey);
        }
        if (node.children) {
          node.children.forEach((child) => {
          findParentKeys(child);
        });
      }
    };
    filteredData.forEach((item) => {
      findParentKeys(item);
    });
    
    // Filter out duplicate parent keys
    // setExpandedKeys(prev => [...new Set(prev)]);
    // setAutoExpandParent(true);
  };
  
  // // Debounce the filtering function
  const debouncedFilterData = debounce(filterData, 300);
  debouncedFilterData(searchValue);

  }, [searchValue, leftTranslatedData]);

  const currTabBodyData = state.treeData[state.treeData.currentScreen]?.leftTree?.tree?.body?.translatedData || false;

  useEffect(() => {
    if (
      state.queryParams.loadTemplateOnLanding &&
      currTabBodyData.length > 0 && 
      urlParams.workflowGroupName && 
      urlParams.template && 
      urlParams.baseUrl &&
      urlParams.user &&
      urlParams.account
    ) {

      dispatch(setLoadTemplateOnLanding(false));
      const targetWfg = urlParams.workflowGroupName;
      const targetTemplate = urlParams.template;

      dispatch(treeActions.setForceTemplate({
        template: targetTemplate,
        workflowGroup: targetWfg,
        screen: parentScreen,
        // forceSelect: true
      }));
    }
  }, [state.queryParams.loadTemplateOnLanding]);

  const switcherIcon = (obj) => {
    if (obj.isLeaf) return;
    if (obj.expanded) return <ArrowDropDownIcon />
    else return <ArrowRightIcon sx={{color: '#666666'}}/>
  }

  function getKeys(translatedData) {
    const keys = [];
  
    function collectKeys(node) {
      if (node && node.key) {
        keys.push({
          key: node.key,
          isParent : node?.type === "workflowGroup"
        });
      }
  
      if (node && Array.isArray(node.children)) {
        for (const child of node.children) {
          collectKeys(child);
        }
      }
    }
  
    for (const item of translatedData) {
      collectKeys(item);
    }
  
    return keys;
  }

  function collectNodes(treeData,collectedNodes = {}) {
    if (Array.isArray(treeData)) {
      for (const item of treeData) {
          collectedNodes[item.key] = item;
          if (item.children) {
          collectNodes(item.children,collectedNodes);
        }
      }
    }
    return collectedNodes;
  }

  const translatedDataKeys = getKeys(leftTranslatedData);
  const collectedNodes = collectNodes(leftTranslatedData);

  const handleKeyDown = (event) => {
    event.preventDefault();
    const expandAndCollapseNode = (isExpand) =>{
      if(selectedNode?.children?.length && isExpand && !expandedKeys?.filter(e => e === selectedNode.key)?.length){
        setExpandedKeys(prev => [...prev, selectedNode.key]);
      }else if (selectedNode?.children?.length && !isExpand && expandedKeys?.filter(e => e === selectedNode.key)?.length){
        setExpandedKeys(prev => prev.filter(e => e !== selectedNode.key));
      }
    }

    const navigate = (offset) => {
      if (selectedKeys.length === 0 || rightTree.loading || leftTree.loading)  return;
      const currentIndex = translatedDataKeys.reduce((acc, ele, index) => ele?.key === selectedKeys[0] ? index : acc ,0);
      let newIndex = currentIndex + offset;
      let nextNodeKey = translatedDataKeys[newIndex]?.key;
      let nextNode = collectedNodes[nextNodeKey];
      const sameLevelOrAboveLevelNodeIndex = getSameLevelOrAboveLevelNode(translatedDataKeys, selectedNode?.key, currentIndex,offset);

      if ((!expandedKeys?.filter(e => e === selectedNode.key)?.length && nextNodeKey.indexOf(selectedNode?.key) !== -1)
      || (!expandedKeys?.filter(e => e === translatedDataKeys[sameLevelOrAboveLevelNodeIndex]?.key)?.length && nextNodeKey.indexOf(translatedDataKeys[sameLevelOrAboveLevelNodeIndex]?.key) !== -1 && offset === -1)
      ){ 
        nextNodeKey = translatedDataKeys[isNaN(sameLevelOrAboveLevelNodeIndex) ? currentIndex : sameLevelOrAboveLevelNodeIndex]?.key ;
        nextNode = collectedNodes[nextNodeKey];
      }


      if (newIndex < 0 || newIndex >= translatedDataKeys.length || !nextNodeKey ){
        return;
      }
      
      setSelectedKeys([nextNodeKey]);
      dispatch(
        treeActions.setLeftTreeSelectedNode({
          screen: parentScreen,
          type: 'body',
          data: nextNode,
        })
      );
      handleWorkflowSelect({node: nextNode});
    };
    if (event.ctrlKey) {
      if (event.key === "c" || event.key === "C") {
        if (selectedNode.type === 'workflowGroup') {
          const message = `${t('BOX_SEL_FILE_TO_COPY')}.\n${selectedNode.title}\t${t('_FRG_IS_A_DIR')}`;
          setErrorModal(true);
          setErrorMessage(message);
        } else if (selectedNode.type === 'inboundTemplate') {
          setCopyInboundModal(true);
        }
      }
    } else if (event.key === "Delete") {
      if (selectedNode.type === "workflowGroup") {
        setErrorModal(true);
        setErrorMessage(t("BOX_SEL_WF_GROUP__SEL_IN_TEM_TO_DEL"));
      } else if (selectedNode.type === "inboundTemplate") {
        setDeleteInboundModal(true);
      }
    } else if (event.key === "ArrowUp") {
      navigate(-1);
    } else if (event.key === "ArrowDown") {
      navigate(1);
    }else if (event.key === "ArrowRight") {
      expandAndCollapseNode(true);
    } else if (event.key === "ArrowLeft") {
      expandAndCollapseNode(false);
    }
  };

  return (
    <>
      <div
        id={parentScreen === "outbound" ? "ob-wf-tree" : parentScreen === 'inbound' ? "ib-wf-tree" : "workflow-tree"}
        onKeyDown={handleKeyDown} tabIndex={0}
        className={leftTree.loading ? "opacity-75" : "wfg-tree"}
        style={{ margin: "0 5px", userSelect: "none" }}>
        {leftTranslatedData.length ? (
          <Tree
            ref={treeRef}
            className="myCls"
            selectedKeys={selectedKeys}
            expandedKeys={[...((searchValue?.length && searchValue?.trim("")?.length && tempExpendedKeys?.length) ? tempExpendedKeys : expandedKeys)]}
            showLine
            onExpand={onExpand}
            onSelect={(...arg) => {
              const callFunction = createThrottledFunction(onSelect, 1000, ...arg);
              callFunction();
            }}
            // treeData={leftTranslatedData}
            autoExpandParent={true}
            treeData={treeData}
            draggable
            icon={Icon}
            titleRender={titleRender}
            showIcon
            onDragStart={onDragStart}
            onDrop={onDrop}
            onRightClick={(...arg) => {
              const callFunction = createThrottledFunction(onRightClick, 1000, ...arg);
              callFunction();
            }} 
            switcherIcon={switcherIcon}
            disabled={rightTree.loading || leftTree?.loading}
            
          />
        ) : (
          "Loading Tree"
        )}
      </div>
      {show ? (
        <DragDropTemplate
          openModal={show}
          toggle={() => setShow(!show)} 
          draggedTempInfo={draggedTempInfo}
          template={draggedTemp}
          wfg={sourceWfg}
          draggedNode= {draggedNode}
          destinationWfg={destinationWfg}></DragDropTemplate>
      ) : (
        ""
      )}
      {errorModal && (
        <ErrorModal
          errorModal={errorModal}
          errorMessage={errorMessage}
          handleErrorModal={() => setErrorModal(false)}></ErrorModal>
      )}
      {copyInboundModal && (
        <CopyInboundTemplate
          openModal={copyInboundModal}
          toggle={() => setCopyInboundModal(false)}></CopyInboundTemplate>
      )}
      {deleteInboundModal && (
        <DeleteInboundTemplate
          openModal={deleteInboundModal}
          toggle={() => setDeleteInboundModal(false)}
        ></DeleteInboundTemplate>
      )

      }
    </>
  );
}

const UnsavedNode = ({ node, unsavedWfg }) => {
  const { t } = useTranslation();
  const [nodeHover, setNodeHover] = useState(false);

  const handleMouseEnter = (e) => setNodeHover(true);
  const handleMouseLeave = () => setNodeHover(false);

  const UnsavedMessage = () => {
    return <div className="margin-left-8" style={{color: '#B5B5B5'}}>
      {unsavedWfg ? 
        t('Workflow Group has one or more unsaved templates') 
        : t('Template has unsaved changes')
      }
    </div>
  }

  return (
    <div 
      onMouseEnter={handleMouseEnter} 
      onMouseLeave={handleMouseLeave}
      onFocus={handleMouseEnter} 
      onBlur={handleMouseLeave}
      data-key={node.key}
      className="flex"
    >
      <div style={{fontWeight: 'bold'}}>{node.title}*</div>
      {nodeHover && <UnsavedMessage/>}
    </div>
  )
}

const UnsavedNodeAlt = ({ node, unsavedWfg }) => {
  const { t } = useTranslation();

  return (
    <div data-key={node.key}>
      <AboveTooltip
        title={unsavedWfg ? t(`Workflow Group contains unsaved changes`) : t(`Template has unsaved changes`)}
        placement="right"
      >
        <div style={{fontWeight: 'bold'}}>{node.title} *</div>
      </AboveTooltip>
    </div>
  )
}

const AboveTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }}/>
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: '#444444',
    boxShadow: theme.shadows[1],
    fontSize: 12,
    fontWeight: 500,
    padding: '4px',
    border: '1px #666666 solid'
  },
}));


  // This Function is returning node at same level or Node at above level (parent nodes level);
  export const getSameLevelOrAboveLevelNode = (data, key, index, offset) => {
    let newIndex = index;
    for (let i = 0 ; i < data.length ; i++){
      if (offset === 1 && i > index && data[i]?.key?.split('-').length <= key?.split('-')?.length) {
        newIndex = i;
        break;
      }
      else if (offset === -1 && i < index && data[i]?.key?.split('-').length <= key?.split('-')?.length) {
        newIndex =i;
      }
    }
    return newIndex;
  }